import type { Dictionary, UUID } from '@protector/utils/types';
import type { AppState, GlobalUiState, Selector } from '../../__legacy__/redux.types.ts';
import type { PropertyState } from '../../property/__legacy__/redux.types.ts';
import type { CurrentSeasonArea } from '../../property/models.ts';

export const getSelectedPropertyId: Selector<GlobalUiState['selectedProperty']> = state => state.uiState.global.selectedProperty;

export const getCurrentSeasonFields: Selector<CurrentSeasonArea[]> = (state: AppState) => state.entities.property.currentAreaSeasons;

export const getPropertyEntitiesInEntities: Selector<PropertyState['entities']> = state => state.entities.property.entities;

export const getSelectedSeasons: Selector<UUID[]> = state => state.uiState.global.selectedSeasons;

export const getCurrentAreaId: Selector<UUID | null> = state => state.uiState.global.selectedArea ?? null;

export const getSelectedCompanyId: Selector<GlobalUiState['selectedCompany']> = state => state.uiState.global.selectedCompany;

export const getSystemFlags: Selector<Dictionary<boolean | string> | null> = state => state.uiState.global.systemFlags;
